import { DispatchObject } from 'shared/utils/dispatch-object';

export enum InventoryAction {
  ClearState = 'CLEAR_STATE',
  ProductSelected = 'SET_PRODUCT_SELECTED',
  Presentation = 'SET_PRESENTATION',
  ProductList = 'SET_PRODUCT_LIST',
  LotList = 'SET_LOT_LIST',
  Laboratories = 'SET_LABORATORIES',
  Categories = 'SET_CATEGORIES',
  Suppliers = 'SET_SUPPLIERS',
  PresentationTypes = 'SET_PRESENTATION_TYPES',
  CodeTypes = 'SET_CODE_TYPES',
}

export type InventoryDispatchObject<T> = DispatchObject<InventoryAction, T>;
